import STUDENT_CERT_TYPES from './_actionTypes';

const DEFAULT_FILTERS = {
  search: '',
  college_id: '',
  degree: '',
  batch: '',
  current_semester: '',
  academic_year: '',
  enrollment_status: '',
  certificate_status: 'all',
  sort_by: 'candidate_name',
  sort_order: 'asc',
  page: 1,
  limit: 20,
};

const initialState = {
  students: [],
  pagination: { total: 0, page: 1, limit: 20, totalPages: 0, hasNext: false, hasPrev: false },
  filters: { ...DEFAULT_FILTERS },
  loading: false,
  error: null,

  studentDetail: null,
  studentDetailLoading: false,
  studentDetailError: null,
};

const studentCertificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_CERT_TYPES.FETCH_STUDENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case STUDENT_CERT_TYPES.FETCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students,
        pagination: action.payload.pagination,
      };
    case STUDENT_CERT_TYPES.FETCH_STUDENTS_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_REQUEST:
      return { ...state, studentDetailLoading: true, studentDetailError: null };
    case STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_SUCCESS:
      return { ...state, studentDetailLoading: false, studentDetail: action.payload };
    case STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_FAILURE:
      return { ...state, studentDetailLoading: false, studentDetailError: action.payload.error };
    case STUDENT_CERT_TYPES.CLEAR_STUDENT_DETAIL:
      return { ...state, studentDetail: null, studentDetailError: null };

    case STUDENT_CERT_TYPES.SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case STUDENT_CERT_TYPES.RESET_FILTERS:
      return { ...state, filters: { ...DEFAULT_FILTERS } };

    default:
      return state;
  }
};

export default studentCertificatesReducer;
